<form [formGroup]="zorgToeslagFg">
  <div>
    <snelstart-ui-number-form-control (change)="saveForm()"
                                      [showAllDecimals]="false"
                                      align="right"
                                      class="custom-input-250"
                                      formControlName="alOntvangenZorgtoeslag"
                                      id="alOntvangenZorgtoeslag"
                                      label="Voorschot zorgtoeslag"
                                      prefix="€"
    >
    </snelstart-ui-number-form-control>
  </div>
</form>
<form [formGroup]="kgbToeslagFg">
  <div>
    <snelstart-ui-number-form-control (change)="saveForm()"
                                      [showAllDecimals]="false"
                                      align="right"
                                      class="custom-input-250"
                                      formControlName="alOntvangenKGB"
                                      id="alOntvangenKGB"
                                      label="Voorschot kindgebonden budget"
                                      prefix="€"
    >
    </snelstart-ui-number-form-control>
  </div>
</form>
<form [formGroup]="kotToeslagFg">
  <div>
    <snelstart-ui-number-form-control (change)="saveForm()"
                                      [showAllDecimals]="false"
                                      align="right"
                                      class="custom-input-250"
                                      formControlName="alOntvangenKOT"
                                      id="alOntvangenKOT"
                                      label="Voorschot kinderopvangtoeslag"
                                      prefix="€"
    >
    </snelstart-ui-number-form-control>
  </div>
</form>
<form [formGroup]="huurToeslagFg">
  <div>
    <snelstart-ui-number-form-control (change)="saveForm()"
                                      [showAllDecimals]="false"
                                      align="right"
                                      class="custom-input-250"
                                      formControlName="alOntvangenHuurtoeslag"
                                      id="alOntvangenHuurtoeslag"
                                      label="Voorschot huurtoeslag"
                                      prefix="€"
    >
    </snelstart-ui-number-form-control>
  </div>
</form>
